import React from 'react';
import SvgIcon from './SvgIcon';
function LoadingDots(_a) {
    var className = _a.className;
    return (React.createElement(SvgIcon, { className: className },
        React.createElement("svg", { className: "loading-dots", width: "34", height: "8", viewBox: "0 0 34 8", fill: "none" },
            React.createElement("circle", { className: "loading-dot loading-dot-1", cx: "4", cy: "4", r: "4", fill: "#333333" }),
            React.createElement("circle", { className: "loading-dot loading-dot-2", cx: "17", cy: "4", r: "4", fill: "#787878" }),
            React.createElement("circle", { className: "loading-dot loading-dot-3", cx: "30", cy: "4", r: "4", fill: "#BEBEBE" }))));
}
export default LoadingDots;
